
//Извлечение бита в регистре
export const checkBit = (num, bitPosition) => (num & (1 << bitPosition)) !== 0;

//проверяем если первые 4шт param = 65535 значит нет связи по RS485
export const checkConnectionSlave = (item, paramNames = ['param1', 'param2', 'param3', 'param4', 'param5']) => {
  const validValues = ["65535", "0"];
  return paramNames.every(param => validValues.includes(item?.[param]));
};

//определяем наличие насосного агрегата
export const checkExistNA = (param) => param !== '65535' && param !== '0' && param !== '*';

//извлекаем из регистра состояние 0-3-состояние, 4-7-неисправности, 8-15-ошибки ПЧ
export const parseBits = (num) => {
  // Проверяем, что число в диапазоне 0-65535
  if (num < 0 || num > 65535) return null; 
  return {
      bits0to3: num & 0b1111, // биты 0-3
      bits4to7: (num & 0b11110000) >>> 4, // биты 4-7
      bits8to15: (num & 0b1111111100000000) >>> 8 // биты 8-15
  };
};

//определяем состояние насосного агрегата
export const stateNA = (param) => {
  // Приводим параметр к числу, если он строка
  const numericParam = typeof param === 'string' ? parseInt(param, 10) : param;
  switch (numericParam) {
    case 1: return 'В работе';
    case 2: return 'В работе';
    case 3: return 'Останов';
    case 4: return 'Авария';
    case 5: return 'Готов к работе';
    default: return '...';
    }
};

// Функция для подготовки параметра (знаков после ',' ед изм)
export const formatParametr = (param, decimalPlaces = 1, unit = 'Гц') => {
  if (!param || param==='65535') return '...';
  const number = parseFloat(param);
  if (isNaN(number)) return '...';
  const divisor = Math.pow(10, decimalPlaces);
  return `${(number / divisor).toFixed(decimalPlaces)} ${unit}`;
};

    // Функция для подготовки данных Частотника время разгона и торможения, верхняя и нижняя скорость.
    export  const preparePchTimeAndSpeed = (typeRsDevice, param2, param3, param4, param5) => {
      let pchData = {};
      switch(typeRsDevice) {
          case 'PCH_Instart':
              pchData.highSpeed = formatParametr(param2, 2, '');
              pchData.lowSpeed = formatParametr(param3, 2, '');
              pchData.timeAcceleration = formatParametr(param4, 1, '');
              pchData.timeDeceleration = formatParametr(param5, 1, '');
              break;
          case 'PCH_ESQ':
              pchData.highSpeed = formatParametr(param2, 2, '');
              pchData.lowSpeed = formatParametr(param3, 2, '');
              pchData.timeAcceleration = formatParametr(param4, 1, '');
              pchData.timeDeceleration = formatParametr(param5, 1, '');
              break;
          case 'PCH_ATV':
              pchData.highSpeed = formatParametr(param2, 1, '');
              pchData.lowSpeed = formatParametr(param3, 1, '');
              pchData.timeAcceleration = formatParametr(param4, 1, '');
              pchData.timeDeceleration = formatParametr(param5, 1, '');
              break;
  
              default:
                  return null;
          }
          return pchData;
  }
